<!--
 * @Description: file content
 * @Author:
 * @Date: 2023-08-22 11:43:41
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-04-09 15:22:19
-->
<script setup lang="tsx">
import { RouterView } from 'vue-router'
import { useUserStore } from '@/store'
import { getExpirationRemind } from '@/api'
import { useAuthStoreWithout } from '@/store/modules/auth'
import { WorkspaceType, useWorkspaceStore } from '@/store/modules/workspace'
import mitt from '@/event-bus'
import NewUserNotive from '@/components/NewUserNotive/index.vue'
const authStore = useAuthStoreWithout()

const workspaceStore = useWorkspaceStore()
const route = useRoute()
const userStore = useUserStore()
const userInfo = ref(userStore.userInfo)
const userInfoComputed = computed(() => userStore.userInfo)

// 能量点提醒
const showRemind = ref(userStore.userInfo?.showRemind || false)
function closeRemind() {
  showRemind.value = false
  userStore.updateUserInfo({ showRemind: false })
}
async function getRemind() {
  try {
    const { expirationAmount, expirationTime } = userInfo.value
    if (expirationAmount && expirationTime) {
      return
    }
    if (!expirationAmount || !expirationTime) {
      // 请求接口 获取最新能量点到期情况
      const resp: any = await getExpirationRemind()
      const { expirationAmount, expirationTime } = resp
      showRemind.value = !!(expirationAmount && expirationTime)

      userStore.updateUserInfo({ expirationAmount, expirationTime, showRemind: showRemind.value })
      userInfo.value = userStore.userInfo
    }
  } catch (error) { }
}
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    // 可见时执行的代码
    showRemind.value = JSON.parse(localStorage.getItem('userStorage') as string)?.data.userInfo.showRemind
    userInfo.value = JSON.parse(localStorage.getItem('userStorage') as string)?.data.userInfo
    getRemind()
  } else {
    // 不可见时执行的代码
  }
})

onMounted(async () => {
  if (!authStore.token) {
    return
  }

  try {
    const resp: any = await getExpirationRemind()

    const { expirationAmount, expirationTime } = resp
    if (userInfo.value && (userInfo.value.expirationAmount !== expirationAmount || userInfo.value.expirationTime !== expirationTime)) {
      showRemind.value = !!(expirationAmount && expirationTime)
      userStore.updateUserInfo({ expirationAmount, expirationTime, showRemind: showRemind.value })
      userInfo.value = userStore.userInfo
    }
  } catch (error) { }
})

watch(userInfoComputed, () => {
  userInfo.value = userInfoComputed.value
  showRemind.value = userInfo.value.showRemind
})

const mainHeight = computed(() => {
  let diffHeight = 56
  if (showRemind.value) {
    diffHeight += 48
  }
  return `calc(100vh - ${diffHeight}px)`
})
// 是否有空间
const hasWorkspace = computed(() => {
  const hasSpace = workspaceStore.workspaceList?.find(item => item.workspaceType !== WorkspaceType.Check)
  return workspaceStore.workspaceList.length && hasSpace
})
// 是否是市场洞察 agent 报告详情页
const isMarketInsightAgentReportDetail = computed(() => {
  return route.path.includes('/market-agent-report')
})

const isActivityBannerShow = ref(false)
function closeActivity624() {
  isActivityBannerShow.value = false
  mitt.emit('closeActivityBanner')
}
function handleBannerClick() {
  window.open('https://m.beautydatalink.com/#/activityHybridDetail?id=622&enterpriseId=10000105&menuIndex=0&functionIndex=0&shareId=1500053', '_blank')
}
onMounted(() => {
  setTimeout(() => {
    isActivityBannerShow.value = true
  }, 1000)
  // setTimeout(() => {
  //   isActivityBannerShow.value = false
  // }, 5000)
})
</script>

<template>
  <div v-if="isActivityBannerShow" class="app-top-banner" @click="handleBannerClick">
    <div class="close" @click.stop="closeActivity624" />
  </div>
  <div class="app-wrapper flex" :class="{ 'activity-banner-show': isActivityBannerShow }">
    <AppMenu />

    <div class="app-main-layout flex flex-1 flex-col">
      <AppHeader />
      <!-- 能量点提醒 -->
      <div v-if="showRemind && userInfo && userInfo.expirationTime && userInfo.expirationAmount" class="remind-wrap">
        <div class="remind-content">
          <div class="remind-icon" />
          您在{{ workspaceStore.currentWorkspace.workspaceName }}有{{ userInfo.expirationAmount }}个能量点将于{{
            userInfo.expirationTime }}天后过期，请尽快使用
        </div>
        <button class="close-btn" :data-ph-capture-attribute-page-actions="$getPosthogPath(['关闭能量点到期提醒'])"
          @click="closeRemind" />
      </div>

      <Breadcrumb />
      <RouterView />
    </div>

    <!-- // 续费咨询弹窗 -->
    <AppSystemReneval />
    <!-- 用户引导 -->
    <!-- <UserGuide v-if="hasWorkspace && !isMarketInsightAgentReportDetail" /> -->
    <!-- 新用户提醒弹窗 -->
    <NewUserNotive />


  </div>
</template>

<style lang="scss">
.app-top-banner {
  position: relative;
  height: 60px;
  // background-color: #FCC5D8;
  // background-image: url('https://materialdb.zhaoyl.com/fed/cowork/app-top-banner.png');
  background-image: url('https://materialdb.zhaoyl.com/fed/top-banner-2026-1.jpg');
  // background-size: auto 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;

  .close {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background-image: url('https://materialdb.zhaoyl.com/fed/cowork/app-top-banner-close.png');
    background-size: cover;
    cursor: pointer;
  }
}

.app-wrapper {
  width: 100%;
  height: 100vh;

  &.activity-banner-show {
    height: calc(100vh - 60px);
  }
}

.remind-wrap {
  position: relative;
  z-index: 2000;
  width: 100%;
  padding: 13px 0;
  background: #FEF7EA;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .remind-content {
    margin-left: 36px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #EF9702;
    line-height: 22px;

    .remind-icon {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      background: url('./icons/remind-icon.png') no-repeat;
      background-size: contain;
    }
  }

  .close-btn {
    width: 20px;
    height: 20px;
    margin-right: 14px;
    background: url('./icons/close-icon.png') no-repeat;
    background-size: contain;
  }
}

.app-main-layout {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .main-layout {
    position: relative;
    flex: 1;
    min-width: calc(100% - 180px);
    height: 100%;
  }
}
</style>
